import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import mbLogo from '../assets/milwaukee-ballet-logo.png';
import agmaMark from '../assets/agma-mark.png';
import { apiFetch } from '../utils/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await apiFetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setSubmitted(true);
    } catch {
      setError('Network error — please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-page'>
      <div className='login-card'>
        <div className='login-brand'>
          <img src={mbLogo} alt='Milwaukee Ballet' className='login-logo' />
          <h1 className='login-title'>PROSCENO</h1>
          <p className='login-subtitle'>Reset your password</p>
        </div>

        {submitted ? (
          <div className='forgot-pw-success'>
            <p>If that email is registered you will receive a reset link shortly.</p>
            <Link to='/login' className='forgot-pw-back-link'>Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p className='forgot-pw-instructions'>
              Enter your account email and we'll send you a link to reset your password.
            </p>
            <div className='user-form-field'>
              <label htmlFor='email'>Email</label>
              <input
                id='email'
                type='email'
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoComplete='email'
              />
            </div>
            {error && <p className='login-error'>{error}</p>}
            <button type='submit' className='login-submit-btn' disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
            <div className='forgot-pw-footer'>
              <Link to='/login' className='forgot-pw-back-link'>Back to sign in</Link>
            </div>
          </form>
        )}
      </div>

      <div className='login-footer'>
        <img src={agmaMark} alt='AGMA' className='login-footer-mark' />
        <span>
          This system implements the photo approval rights guaranteed under the
          AGMA Collective Bargaining Agreement, Section 4, Article 41.
        </span>
      </div>
    </div>
  );
}
